<template>
  <!-- Delete Payment -->
  <v-dialog v-if="showDialog" v-model="showDialog" max-width="500px" persistent>
      <v-card class="pa-4">
          <v-card-title>
              <h2 class="title">Delete Payment</h2>
          </v-card-title>
          <v-card-text>
              <div class="dialog-warning-note">
                  <v-layout class="align-center fill-height">
                      <v-icon left color="error" class="mr-2">error</v-icon>
                      <span class="d-flex">Are you sure you want to delete payment?</span>
                  </v-layout>
              </div>
              <v-alert class="pa-2 mt-4" :value="!serverValidation" outlined color="error" icon="priority_high" transition="scale-transition">
                  <span class="caption">{{ serverValidationMessage }}</span>
              </v-alert>
          </v-card-text>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="closeModal">Cancel</v-btn>
              <v-btn color="primary" :disabled="saveLoading" :loading="saveLoading" @click="DeletePayment">
                  Delete
              </v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import ApiService from "@/common/api.service";
import { mapActions } from "vuex";

export default {
  name: "DeletePayment",
  data: () => ({
    no_data: [null, "", undefined, "null"],
    showDialog: false,
    item: null,
    preparedData: {},
    saveLoading: false,
    serverValidation: true,
    serverValidationMessage: "Oops something went wrong...",
    unsubscribe: null
  }),
  mounted() {
    this.unsubscribe = this.$store.subscribeAction(action => {
      if (action.type === 'vEmit' && action.payload.name === 'DeletePayment') {
        this.openModal(action.payload.data)
      }
    })
  },
  beforeDestroy() {
    this.unsubscribe()
  },
  methods: {
    ...mapActions(['vEmit']),
    openModal(item) {
      this.resetServerValidation();
      this.preparedData = {};
      this.item = item
      this.preparedData = { payment_id: item.id };
      this.showDialog = true;
      this.saveLoading = false;
      this.showDialog = true;
    },
    DeletePayment() {
        this.resetServerValidation()
        let body = { ...this.preparedData }
        this.saveLoading = true 

        ApiService.put( `/payment/delete`, body)
            .then(response => {
                this.saveLoading = false
                this.vEmit({ 
                  name: "notification", 
                  data: {
                    status: 'success', 
                    text: 'Payment has been successfully deleted.'
                  }
                })
                this.closeModal()
                this.vEmit({ name: 'getClientInvoices' })
                this.vEmit({ name: 'getClientBalance' })
                this.$emit('done')
            })
            .catch(({ response }) => {
                this.saveLoading = false
                this.serverValidation = false
                if(response.data.error){
                    this.serverValidationMessage = this.titleCase(response.data.error)
                }
            })
    },
    closeModal() {
        this.showDialog = false;
    },
    titleCase(str) {
      return _.startCase(str.replace(/_/g, " "));
    },
    resetServerValidation() {
      this.serverValidation = true;
      this.serverValidationMessage = "Oops something went wrong...";
    }
  }
};
</script>

<style lang="stylus"></style>
